export const SectionTitle = ({ children }: { children: string }) => (
	<p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{children}</p>
);

export const Required = () => <span className="text-red-500">*</span>;
